import { render } from "./OverallUserRating.vue?vue&type=template&id=e74000f0"
import script from "./OverallUserRating.vue?vue&type=script&lang=js"
export * from "./OverallUserRating.vue?vue&type=script&lang=js"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__